module.exports = __webpack_public_path__ + "static/media/Categories-Selected-Icon-2x.c3b944ff.png";